export const SUPPLIER_CATEGORIES = [
  'Assessoria e cerimonial',
  'Buffet',
  'Convites e papelaria',
  'Decoracao',
  'Doces e bolo',
  'Espaco',
  'Foto e video',
  'Lua de mel',
  'Musica e DJ',
  'Vestidos e trajes',
];

export const BRAZIL_STATES = [
  'AC', 'AL', 'AP', 'AM', 'BA', 'CE', 'DF', 'ES', 'GO', 'MA', 'MT', 'MS',
  'MG', 'PA', 'PB', 'PR', 'PE', 'PI', 'RJ', 'RN', 'RS', 'RO', 'RR', 'SC',
  'SP', 'SE', 'TO',
];

export const SUPPLIER_COVER_FALLBACK = 'https://images.unsplash.com/photo-1511285560929-80b456fea0bc?auto=format&fit=crop&w=1200&q=80';

export const SUPPLIER_PLAN_OPTIONS = [
  {
    id: 'free',
    name: 'Free',
    eyebrow: 'Entrada no diretorio',
    description: 'Para comecar a aparecer no Virei Noiva e validar sua presenca na vitrine de fornecedores.',
    features: [
      'Perfil publico no diretorio',
      '1 categoria principal',
      '1 cidade principal',
      'WhatsApp, Instagram e site',
      'Aprovacao editorial antes de publicar',
    ],
  },
  {
    id: 'premium',
    name: 'Premium',
    eyebrow: 'Mais visibilidade',
    description: 'Para fornecedores que querem mais distribuicao, mais destaque e perfil mais forte.',
    features: [
      'Tudo do Free',
      'Chance de aparecer na home do Virei Noiva',
      'Prioridade maior no diretorio',
      'Mais destaque visual no card',
      'Camada comercial para gerar mais descoberta',
    ],
  },
  {
    id: 'premium_plus',
    name: 'Premium Plus',
    eyebrow: 'Maxima distribuicao',
    description: 'Para quem quer disputar as posicoes mais nobres da vitrine de fornecedores.',
    features: [
      'Tudo do Premium',
      'Prioridade maxima em blocos especiais',
      'Distribuicao reforcada em vitrines premium',
      'Perfil mais aspiracional e mais forte comercialmente',
      'Base ideal para analytics e futuras acoes sazonais',
    ],
  },
];

export function getSupplierPlanMeta(planType) {
  const normalized = String(planType || 'free').trim().toLowerCase();
  if (normalized === 'premium_plus') {
    return {
      label: 'Premium Plus',
      badgeClass: 'bg-[#1C1C1C] text-white',
      accentClass: 'text-[#1C1C1C]',
      cardClass: 'border-[#1C1C1C]/12 bg-[linear-gradient(180deg,#ffffff_0%,#f7f2ee_100%)] shadow-[0_20px_40px_-28px_rgba(28,28,28,0.5)]',
      frameClass: 'ring-1 ring-[#1C1C1C]/10',
      highlightLabel: 'Maxima distribuicao',
    };
  }
  if (normalized === 'premium') {
    return {
      label: 'Premium',
      badgeClass: 'bg-[#C8A97E] text-white',
      accentClass: 'text-[#9A6B65]',
      cardClass: 'border-[#D9BA8D]/45 bg-[linear-gradient(180deg,#fffdfa_0%,#fff4e8_100%)] shadow-[0_18px_36px_-26px_rgba(157,113,72,0.38)]',
      frameClass: 'ring-1 ring-[#D9BA8D]/20',
      highlightLabel: 'Mais visibilidade',
    };
  }
  return {
    label: 'Free',
    badgeClass: 'bg-white text-[#7A5D52] border border-[#E8B7B1]/45',
    accentClass: 'text-[#7A5D52]',
    cardClass: 'border-[#E8B7B1]/35 bg-white shadow-[0_18px_34px_-28px_rgba(28,28,28,0.35)]',
    frameClass: '',
    highlightLabel: 'Entrada no diretorio',
  };
}

export function getSupplierLocationLabel(supplier) {
  const city = String(supplier?.city || '').trim();
  const state = String(supplier?.state || '').trim();
  if (city && state) return `${city}, ${state}`;
  return city || state || 'Local a definir';
}

export function normalizeWhatsappLink(value) {
  const digits = String(value || '').replace(/\D/g, '');
  if (!digits) return null;
  return `https://wa.me/${digits}`;
}

export function normalizeInstagramLink(value) {
  const handle = String(value || '').trim().replace(/^@/, '').replace(/^https?:\/\/(www\.)?instagram\.com\//i, '').replace(/\/+$/, '');
  if (!handle) return null;
  return `https://instagram.com/${handle}`;
}

export function getSupplierPrimaryContactLink(supplier) {
  return normalizeWhatsappLink(supplier?.whatsapp)
    || normalizeInstagramLink(supplier?.instagram)
    || String(supplier?.website_url || '').trim()
    || null;
}
